import script from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=js"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=bbb4223c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbb4223c"]])

export default __exports__